<template>
  <div class="hello">
    <header class="header ui-header-positive ui-border-b" style="padding:0 210px">
      <ul class="ui-tiled">
        <div><img src="/static/img/logo.png" /> </div>
        <router-link to="/devicemanage" tag="li"><div>设备控制</div></router-link>
        <router-link to="/addDevice" tag="li"><div>添加设备</div></router-link>
        <router-link to="/userManage" tag="li"><div>用户管理</div></router-link>
        <router-link to="/msgLog" tag="li"><div>消息记录</div></router-link>
        <router-link to="/send" tag="li"><div>指令群发</div></router-link>
        <router-link to="/baidu" tag="li"><div>地图位置</div></router-link>
         <!--<router-link to="/setsong" tag="li"><div>报警设置</div></router-link>-->
        <router-link to="/info" tag="li"><div>个人信息</div></router-link>
        <li v-on:click="logOut()"><div  >退出</div></li>
      </ul>
    </header>
  </div>
</template>

<script>
	//相当于暴露一个借口，供其他组件import
export default {
  name: 'headlink',
  data () {
    return {

    }
  },
  methods:{
    logOut:function(){
      const history = window.sessionStorage;
			var uid = history.setItem("user","");
      this.$router.push("/register");
    }
  },
 mounted: function(){
    
  },
  components: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/headlink.vue